import { render, staticRenderFns } from "./JSelectDeparts.vue?vue&type=template&id=befa99c8&scoped=true"
import script from "./JSelectDeparts.vue?vue&type=script&lang=js"
export * from "./JSelectDeparts.vue?vue&type=script&lang=js"
import style0 from "./JSelectDeparts.vue?vue&type=style&index=0&id=befa99c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befa99c8",
  null
  
)

export default component.exports